
export default {
  name: "CreditsSection",
  props: ['zone']
}
